import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { buildCitcatUrlFromMsaAlias, formatMsaNameFromAlias } from './CitcatLinks.helpers';
import { messages } from './CitcatLinks.messages';
export var CitcatLinksUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(CitcatLinksUnwrapped, _Component);

  function CitcatLinksUnwrapped(props) {
    var _this;

    _classCallCheck(this, CitcatLinksUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CitcatLinksUnwrapped).call(this, props));
    _this.renderLink = _this.renderLink.bind(_assertThisInitialized(_this));
    _this.renderComingSoon = _this.renderComingSoon.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CitcatLinksUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Sell Experience', 'View Module', 'CitcatLinks', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "renderSection",
    value: function renderSection(region, cities, comingSoon) {
      var regionName = region.replace(/\b[a-z]/g, function (x) {
        return x.toUpperCase();
      }).replace('-', ' ');
      var comingSoonList = comingSoon || [];
      return React.createElement("div", {
        key: region,
        className: "grid__item 1/2 md-1/3 lg-1/6 color-text-light"
      }, React.createElement("h6", {
        className: "mb-"
      }, regionName), React.createElement("ul", {
        className: "mb"
      }, cities.map(this.renderLink), comingSoonList.map(this.renderComingSoon)));
    }
  }, {
    key: "renderLink",
    value: function renderLink(msaAlias) {
      var msaLink = buildCitcatUrlFromMsaAlias(msaAlias);
      var msaName = formatMsaNameFromAlias(msaAlias);
      return React.createElement("li", {
        key: msaAlias
      }, React.createElement("a", {
        className: "block pv-- color-text-light",
        href: msaLink,
        onClick: function onClick() {
          return ga('Sell Experience', 'Click MSA CitCat Link', msaName, '1');
        }
      }, msaName));
    }
  }, {
    key: "renderComingSoon",
    value: function renderComingSoon(msaAlias) {
      var msaName = formatMsaNameFromAlias(msaAlias);
      return React.createElement("li", {
        className: "pv-- color-text-light",
        key: msaAlias
      }, React.createElement(FormattedMessage, _extends({}, messages.comingSoon, {
        values: {
          msaName: msaName
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // TODO i18n
      var locations = [['east-coast', ['baltimore', 'boston', 'new-york', 'philadelphia', 'pittsburgh', 'washington-d.c.']], ['southeast', ['atlanta', 'charlotte', 'miami', 'nashville', 'new-orleans', 'orlando', 'raleigh', 'tampa']], ['midwest', ['chicago', 'cincinnati', 'columbus', 'denver', 'indianapolis', 'kansas-city', 'milwaukee', 'minneapolis', 'st.-louis']], ['west-coast', ['honolulu', 'inland-empire', 'los-angeles', 'missoula', 'portland', 'sacramento', 'salt-lake-city', 'san-diego', 'san-francisco', 'seattle']], ['southwest', ['austin', 'dallas', 'houston', 'las-vegas', 'phoenix', 'san-antonio']], ['international', ['adelaide', 'brisbane', 'bristol', 'calgary', 'germany', 'hong-kong', 'india', 'indonesia', 'london', 'malaysia', 'manchester', 'melbourne', 'netherlands', 'new-zealand', 'perth', 'philippines', 'singapore', 'sydney', 'thailand', 'toronto', 'united-arab-emirates', 'vancouver']]];
      return React.createElement("div", {
        className: "citcat-links bg--".concat(this.props.backgroundColor || 'white')
      }, React.createElement("div", {
        className: "wrap ph pt+ pb md-ph+ md-pv++"
      }, React.createElement("h2", {
        className: "gamma text--center mb+"
      }, React.createElement(FormattedMessage, messages.header)), React.createElement("hr", {
        className: "mt mb+ md-hidden"
      }), React.createElement("div", {
        className: "grid"
      }, locations.map(function (section) {
        return _this2.renderSection(section[0], section[1], section[2]);
      }))));
    }
  }]);

  return CitcatLinksUnwrapped;
}(Component);
CitcatLinksUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light'])
};
export var CitcatLinks = trackDwell(CitcatLinksUnwrapped);